var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var Svg4Star = function Svg4Star(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50,5C25.187,5,5,25.187,5,50s20.187,45,45,45s45-20.187,45-45S74.813,5,50,5z M50,90c-22.056,0-40-17.944-40-40   s17.944-40,40-40s40,17.944,40,40S72.056,90,50,90z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.759,
    cy: 41.599,
    r: 5.683
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.241,
    cy: 41.599,
    r: 5.683
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.095,59.006c-9.025,8.045-23.165,8.045-32.19,0c-1.03-0.919-2.611-0.829-3.53,0.203   c-0.919,1.031-0.828,2.611,0.203,3.53C36.023,67.592,43.012,70.02,50,70.02s13.977-2.427,19.422-7.281   c1.031-0.919,1.122-2.499,0.203-3.53C68.706,58.177,67.125,58.087,66.095,59.006z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg4Star, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/4star.76a978db.svg";
export { ForwardRef as ReactComponent };